import { lazy } from "react";
import type { SolutionRoute } from "../routes";
import type { SolutionSettings } from "../settings";
import "./media.css";

const AlbumPage = lazy(() => import("./album").then((m) => ({ default: m.AlbumPage })));
const GalleryMoved = lazy(() => import("./media-page").then((m) => ({ default: m.GalleryMoved })));
const MediaPage = lazy(() => import("./media-page").then((m) => ({ default: m.MediaPage })));

/** Media: the media library (every picture in the business) and its albums, published to the members' site's gallery. */

export const routes: SolutionRoute[] = [
  { solution: "media", path: "media", element: <MediaPage /> },
  { solution: "media", path: "gallery", element: <GalleryMoved /> },
  { solution: "media", path: "gallery/:id", element: <AlbumPage /> },
];

export const settings: SolutionSettings[] = [];
